import { FC } from 'react';

import EditAddressButton from '@/components/common/EditAddressButton/EditAddressButton';

import { AddressIcon } from '@/components/ui/Icons';

import useAddress from '@/lib/api/accountManager/hooks/useAddress';
import { TypePlayGeniusOrder } from '@/lib/api/orderManager/types/TypePlayGeniusOrder';

import { TypeAccountERCTranslations } from '@/utils/translations/types/TypeAccountERCTranslations';

import { InfoRow } from '../../../../../../_components/InfoRow';

interface ShippingAddressProps {
  t: TypeAccountERCTranslations;
  orderData: TypePlayGeniusOrder;
  subscriptionId?: string;
}

const ShippingAddress: FC<ShippingAddressProps> = ({
  t,
  orderData,
  subscriptionId,
}) => {
  const { addressData, addressLoading } = useAddress(
    orderData.shipping_address.original_uuid,
  );

  return (
    <InfoRow
      icon={AddressIcon}
      label={t.shippingAddress}
      value={addressLoading ? t.loading : addressData?.line1}
      shouldHideOverflow
    >
      {addressData && (
        <EditAddressButton
          addressId={addressData.uuid}
          label={t.edit}
          subscriptionId={subscriptionId}
        />
      )}
    </InfoRow>
  );
};

export default ShippingAddress;
